import { PROMISE_RESOLVE_FALSE as t, categorizeBulkWriteRows as e, ensureNotFalsy as a, promiseWait as n, requestIdlePromiseNoQueue as r } from "rxdb/plugins/core";
import { attachmentObjectId as o, ensureNotClosed as s, createTx as c, runReadTask as m, indexedDBHasAtLeastOneRow as d } from "./indexeddb-helpers.js";
import { indexedDBFindByIdsInternal as h } from "./indexeddb-find-by-ids.js";
export async function bulkWrite(i, l, u) {
  var p = i.primaryPath,
    w = i.internals,
    v = i.internals.state;
  await v.creationPromise;
  var f = [w.storeNames.documentStore, w.storeNames.writeAheadStore];
  i.schema.attachments && f.push(w.storeNames.attachmentsStore), s(i);
  var g,
    I = await c(i),
    b = I.objectStore(w.storeNames.documentStore);
  g = 0 === i.internals.minKnownDocsAmount && l.length > 30 && !(await d(i, b)) ? new Map() : await h(p, b, l);
  for (var y = e(i, p, g, l, u), D = y.errors, S = y.bulkInsertDocs, k = new Array(S.length), A = 0; A < S.length; ++A) {
    var N = S[A].document;
    k[A] = N;
  }
  for (var P, j = y.bulkUpdateDocs, x = 0; x < j.length; ++x) {
    var W = j[x].document;
    k.push(W);
  }
  if (k.length > 0) {
    var B = I.objectStore(w.storeNames.writeAheadStore).put({
      i: "documents",
      docsData: JSON.stringify(k)
    });
    await new Promise((t, e) => {
      B.onerror = e, B.onsuccess = t;
    }), i.handleWalIdlePromise || n(100).then(() => r()).then(async () => {
      i.handleWalIdlePromise = void 0, i.closed || (await m(i, () => t));
    });
  }
  if (i.schema.attachments) {
    var E = I.objectStore(i.internals.storeNames.attachmentsStore);
    y.attachmentsAdd.forEach(t => {
      P = E.put({
        docIdWithAttachmentId: o(t.documentId, t.attachmentId),
        length: t.attachmentData.length,
        type: t.attachmentData.type,
        data: t.attachmentData.data
      });
    }), y.attachmentsUpdate.forEach(t => {
      P = E.put({
        docIdWithAttachmentId: o(t.documentId, t.attachmentId),
        length: t.attachmentData.length,
        type: t.attachmentData.type,
        data: t.attachmentData.data
      });
    }), y.attachmentsRemove.forEach(t => {
      P = E.delete(o(t.documentId, t.attachmentId));
    });
  }
  if (P && (await new Promise((t, e) => {
    a(P).onerror = e, a(P).onsuccess = t;
  })), I.commit && I.commit(), y.eventBulk.events.length > 0) {
    var R = a(y.newestRow).document;
    y.eventBulk.checkpoint = {
      id: R[p],
      lwt: R._meta.lwt
    }, i.changes$.next(y.eventBulk);
  }
  return {
    error: D
  };
}